
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/general-liability",
      function () {
        return require("private-next-pages/general-liability.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/general-liability"])
      });
    }
  